import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Mailchimp from "react-mailchimp-form";
import logo from "../../../img/logo-light.png";

import "./style.scss";

const Index = () => {
  return (
    <footer className="public-footer-container">
      <div className="inner-public-footer-container">
        <Row className="footer-row">
          <Col md className="single-col about-col">
            <Link to="/">
              <img
                className="footer-logo"
                alt="Leadfind logo - finn nye kunder"
                src={logo}
              />
            </Link>
            <p className="footer-description">
              Leadfind er et avansert sky-basert prospecting verktøy som
              forenkler muligheten og prosessen med å finne nye kunder og gjøre
              salgsprosessen enda mer effektiv.
            </p>
          </Col>
          <Col md className="single-col links-col">
            <h4 className="footer-title">Nyttige lenker</h4>
            <div className="links-container">
              <Link to="/personvern">Personvern</Link>
              <Link to="/vilkår">Brukervilkår</Link>
              <Link to="/cookies">Cookies</Link>
              <Link to="/logg-inn">Logg inn</Link>
            </div>
          </Col>
          <Col md className="single-col social-col">
            <h4 className="footer-title">Sosiale medier</h4>
            <p className="footer-description">
              Hold deg oppdatert med siste nytt fra Leadfind på mediene du
              foretrekker.
            </p>
            <div className="social-container">
              <a href="https://www.facebook.com/leadsurfapp/">
                <i class="fab fa-facebook-square"></i>
              </a>
              <a href="https://www.instagram.com/leadsurfapp/">
                <i class="fab fa-instagram"></i>
              </a>
              <a href="">
                <i class="fab fa-linkedin"></i>
              </a>
              <a href="">
                <i class="fab fa-twitter-square"></i>
              </a>
            </div>
          </Col>
          <Col md className="single-col newsletter-col">
            <h4 className="footer-title">Nyhetsbrev</h4>
            <p className="footer-description">
              Abonner på vårt nyhetsbrev helt gratis og følg med på nyheter
              angående fremtidige oppdateringer og ny funksjonalitet.
            </p>
            <div className="subscribe-container">
              <Mailchimp
                action="https://leadsurf.us7.list-manage.com/subscribe/post?u=ab245d9d155bd74218a0d9dc0&amp;id=faca6ddbde"
                fields={[
                  {
                    name: "EMAIL",
                    placeholder: "Email",
                    type: "email",
                    required: true,
                  },
                ]}
                messages={{
                  sending: "Sender..",
                  success: "Takk for ditt abonnement!",
                  error: "Feil, kunne ikke abonnere.",
                  empty: "Du må skrive inn en e-post.",
                  button: "Abonner",
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

export default Index;
